// extracted by mini-css-extract-plugin
module.exports =  {"translate-small":"_translate-small--3Ckwl","translate-medium":"_translate-medium--1fgjK","translate-large":"_translate-large--3qRb4","fade-spinner-in":"_fade-spinner-in--2g4P0"};